'use client';

import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';

import styles from './DropdownMobileMenu.module.scss';
import Button from '@/app/_components/common/button/Button';
import IconPerson from '@/app/_images/ico_person.svg';
import IconLogout from '@/app/_images/ico_logout.svg';
import IconPlus from '@/app/_images/ico_plus.svg';
import UserProfile from '@/app/_components/common/user-profile/UserProfile';
import useAccountStore from '@/app/_stores/accountStore';
import { LINKS } from '@/app/_contants';
import usePostLogout from '@/app/_hooks/queries/usePostLogout';
import { usePathname } from 'next/navigation';
import { ROUTER_PATH } from '@/app/_contants/routerPath';

const DropdownMobileMenu = () => {
  const path = usePathname();
  const pathResult = path.includes('result');
  const pathAccount = path.includes('account');
  const { mutate: postLogout } = usePostLogout();
  const { email } = useAccountStore((state) => state.userInfo);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 767 && isOpen) {
        toggleDropdown();
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isOpen]);

  useEffect(() => {
    const handleClickOverlay = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target && target.classList.contains(styles.dropdownContainer)) {
        toggleDropdown();
      }
    };

    dropdownRef.current?.addEventListener('click', handleClickOverlay);
    return () => {
      dropdownRef.current?.removeEventListener('click', handleClickOverlay);
    };
  }, [isOpen]);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    const menuWrap = dropdownRef.current?.children[1] as HTMLElement;

    // menuWrap이 유효한지 체크
    if (!menuWrap || !menuWrap.children[0]) {
      console.warn('Dropdown menu wrap or its first child is not available.');
      return;
    }
    if (!isOpen) {
      // 드롭다운 열기
      // document.body.style.overflow = 'hidden';
      const menuHeight = menuWrap.children[0].clientHeight;
      menuWrap.style.maxHeight = `${menuHeight}px`;
    } else {
      // 드롭다운 닫기
      // document.body.style.overflow = '';
      menuWrap.style.maxHeight = '';
    }
  };

  // 로그아웃
  const logout = () => {
    postLogout();
  };

  return (
    <div className={`${styles.menuContainer} ${isOpen ? styles.open : ''}`} ref={dropdownRef}>
      <Button typeIcon className={styles.menuButton} ref={buttonRef} onClick={toggleDropdown}>
        <i></i>
      </Button>
      {/* 드롭다운 레이어 */}
      <div className={`${styles.dropdownContainer}`}>
        <div className={styles.dropdownInner}>
          <div className={styles.top}>
            <UserProfile userInfo={email} />

            <ul className={styles.topMenu}>
              <li>
                <Link href={'/account'} className={pathAccount ? 'text-primary' : ''}>
                  <IconPerson />
                  <span>会員情報</span>
                </Link>
              </li>
              <li>
                <Link href={'#'} onClick={logout}>
                  <IconLogout />
                  <span className={'text-danger'}>ログアウト</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* 메뉴 항목 */}
          <div className={styles.btm}>
            <Button tag="a" size={'wide'} href={ROUTER_PATH.UPLOAD}>
              <IconPlus width={20} height={20} />
              新規アップロード
            </Button>

            <ul className={styles.menuList}>
              <li>
                <Link href={ROUTER_PATH.RESULTS} className={pathResult ? 'text-primary' : ''}>
                  結果リスト
                </Link>
              </li>
              <li>
                <Link href={LINKS.FAQ} target={'_blank'}>
                  よくある質問
                </Link>
              </li>
              <li>
                <Link href={'https://forms.gle/8t6yyQAqjJDUiJUE9'} target="_blank">
                  フィードバック
                </Link>
              </li>
              <li>
                <Link href={LINKS.POLICY} target={'_blank'}>
                  利用規約
                </Link>
              </li>
              <li>
                {/* 개인정보 */}
                <Link href={LINKS.PRIVACY} target={'_blank'}>
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropdownMobileMenu;
